// extracted by mini-css-extract-plugin
export default {"ListItem_0":"IssueItem-module__ListItem_0--feI3m"};